import styled from 'styled-components';

export const Container = styled.div`
   width: 100%;
`

export const Select = styled.select`
-webkit-box-align: center;
align-items: center;
background-color: white;
border-color: rgb(240, 240, 240);
border-radius: 0px;
border-style: solid;
border-width: 1px;
cursor: default;
display: flex;
padding-left:10px;
padding-right:10px;
width:100%;
flex-wrap: wrap;
-webkit-box-pack: justify;
justify-content: space-between;
min-height: 40px;
position: relative;
transition: all 100ms ease 0s;
box-sizing: border-box;
outline: 0px !important;
}
`
export const Spinner = styled.div`
color:#848484;
`
